import * as React from 'react';

export interface ErrorBoundaryProps {
  fallbackComponent?: React.ComponentType<any>;
  forceError?: boolean;
  children?: React.ReactNode;
  onError?: (cause: any) => void;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

const Blank = () => null;

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state = { hasError: false, error: undefined };

  static defaultProps = {
    // The default fallback is just to remove a component from the page. This isn't
    // great, but at least it'll prevent a whole page from crashing.
    fallbackComponent: Blank,
  };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, extra: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('Error caught inside ErrorBoundary', { error, extra });
    this.props.onError?.(error);
  }

  render() {
    const { children, fallbackComponent: FallbackComponent, forceError } = this.props;
    const { hasError, error } = this.state;

    if ((hasError || forceError) && FallbackComponent) {
      return <FallbackComponent error={error} />;
    }

    return children;
  }
}
